export default "__VITE_ASSET__YOnYypCJ__"